import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section id="safety" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="rounded-2xl bg-secondary-100/60 border border-secondary-200/50 p-6 md:p-10">
          <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-start">
            <div className="w-14 h-14 md:w-16 md:h-16 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-200/70">
              <i className="ri-shield-check-line text-2xl md:text-3xl text-secondary-700"></i>
            </div>
            <div className="flex-1">
              <span className="inline-block px-3 py-1 text-xs font-label font-semibold text-secondary-700 bg-secondary-100 rounded-full mb-3">
                Safety
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                Is VigorBuy Spreadsheet Safe?
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
                Safety should always come first when using online resources. Here are essential tips to ensure a secure experience when browsing and shopping through the VigorBuy Spreadsheet platform.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
                {[
                  'Verify website addresses before clicking',
                  'Avoid suspicious copies or fake links',
                  'Protect your personal information',
                  'Use secure connections (HTTPS)',
                  'Confirm product details before purchasing',
                  'Check seller ratings and reviews',
                ].map((tip) => (
                  <div key={tip} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                      <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                    </div>
                    <span className="text-sm text-foreground-700">{tip}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/vigorbuy-spreadsheet-safety"
                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-label font-semibold bg-secondary-500 text-background-50 rounded-full hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                Read Complete Safety Guide
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}